// extracted by mini-css-extract-plugin
export default {"r_l":"a25f41f92b _1b2c7982c4","t":"c6ddaf22e8"};